/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { ShieldCheck, Loader2, CheckCircle2 } from "lucide-react";

/** Écran d'information + recueil du consentement horodaté (patient, aidant ou praticien). */
export function ConsentScreen({ seance, onDone, compact }) {
  const [info, setInfo] = useState(null);
  const [lu, setLu] = useState(false);
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/telesoin/information").then(({ data }) => setInfo(data)).catch(() => null); }, []);
  const consent = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/telesoin/seances/${seance.id}/consentement`, { accepte: true, informations_lues: true }); toast.success("Consentement enregistré"); onDone?.(data); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail?.message || e.response?.data?.detail)); }
    setBusy(false);
  };
  if (seance.consentement) {
    return (
      <div data-testid="consent-done" className="flex items-center gap-2 rounded-2xl bg-[#5CB85C]/10 border border-[#5CB85C]/30 px-4 py-3 text-[13px] text-[#2d7a2d]">
        <CheckCircle2 size={18} /> Consentement recueilli le {new Date(seance.consentement.horodatage).toLocaleString("fr-FR", { dateStyle: "medium", timeStyle: "short" })} ({seance.consentement.source} · {seance.consentement.par_nom})
      </div>
    );
  }
  if (!info) return <div className="py-6 grid place-items-center"><Loader2 className="animate-spin text-[#2BA3A0]" /></div>;
  return (
    <div data-testid="consent-screen" className="flex flex-col gap-3">
      <div className="flex items-center gap-2 text-[#0A1426]"><ShieldCheck size={18} className="text-[#2BA3A0]" /><h3 className="font-[Fraunces] text-lg font-bold">{info.titre}</h3></div>
      <div className={`flex flex-col gap-2 ${compact ? "max-h-56 overflow-y-auto pr-1" : ""}`}>
        {info.sections.map((s) => (
          <div key={s.titre} className="rounded-2xl bg-[#F5F3EE] p-3">
            <div className="text-[11px] uppercase tracking-wider font-bold text-[#0A1426]/60">{s.titre}</div>
            <p className="text-[13px] text-[#0A1426] mt-1 leading-relaxed">{s.texte}</p>
          </div>
        ))}
      </div>
      <label className="flex items-start gap-3 text-[13px] text-[#0A1426] cursor-pointer">
        <input data-testid="consent-read-checkbox" type="checkbox" checked={lu} onChange={(e) => setLu(e.target.checked)} className="mt-1 w-5 h-5 accent-[#2BA3A0]" />
        <span>J'ai lu l'information (conditions, alternatives, modalités de règlement).</span>
      </label>
      <label className="flex items-start gap-3 text-[13px] text-[#0A1426] cursor-pointer">
        <input data-testid="consent-accept-checkbox" type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} className="mt-1 w-5 h-5 accent-[#2BA3A0]" />
        <span className="font-bold">{info.consentement}</span>
      </label>
      <Button data-testid="consent-submit-btn" disabled={!lu || !ok || busy} onClick={consent} className="h-12 rounded-full bg-[#2BA3A0] text-white font-bold">
        {busy ? <Loader2 className="animate-spin" size={16} /> : "Donner mon consentement (horodaté)"}
      </Button>
      <p className="text-[10px] text-[#0A1426]/50">{info.disclaimer}</p>
    </div>
  );
}
